module.exports = __webpack_public_path__ + "img/qilin-stage3.4f68615e.png";